<template>
  <ValidationObserver ref="observer" class="transition duration-500 ease-in-out transform w-full"
                      style="transition: all 1s !important"
                      tag="form" @submit.prevent="submit()">
    <div>
      <v-card flat>
        <v-card-text>
          <div v-if="loading" class="text-center">
            <v-progress-circular color="primary" indeterminate></v-progress-circular>
          </div>

          <div class="w-full text-center">
            <div class="float-center">
              <v-chip class="ma-2 p-6" label text-color="black">
                <v-icon left>
                  mdi-label
                </v-icon>
                <b class="pr-2" style="font-size: 15px;">Passing Score:</b>
                <span right style="color: #1B5E20 !important; font-size: 15px;"><b>{{
                    passingScore ?
                        passingScore : "-"
                  }}</b></span>
              </v-chip>
            </div>
            <div v-if="showWarning">
              <v-divider></v-divider>
              <span>
                                <p style="margin-top: 16px">
                                    <v-icon color="info">mdi-information-variant</v-icon>
                                    The course's passing score is not assigned. Please use <a
                                    style="text-decoration: underline; font-style: italic" @click="redirectToCourse()">Here</a> link to
                                    add passing score to the course to continue.
                                </p>
                            </span>
              <v-divider></v-divider>
            </div>
          </div>
          <br/>
          <br/>

          <div class="flex my-4 mb-6 text-center">
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label class="
                                block
                                uppercase
                                tracking-wide
                                text-gray-700 text-xs
                                font-bold
                                mb-2
                                float-right
                            ">Score: </label>
            </div>

            <div class="w-1/3 h-12">
              <validation-provider v-slot="{ errors }" rules="required|min_value:0|max_value:100">
                <input v-model="formValues.score" :disabled="showWarning" class="
                                    shadow
                                    appearance-none
                                    border
                                    rounded
                                    w-full
                                    py-2
                                    px-3
                                    text-gray-700
                                    leading-tight
                                    focus:outline-none focus:shadow-outline
                                    " name placeholder="add score here"
                       type="number" v-on:input="calculateTraineeStatus($event.target.value)"/>
                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="flex my-4 mb-6 pb-3">
            <div class="w-full md:w-1/2 px-3 mb-6">
              <label class="
                                    block
                                    uppercase
                                    tracking-wide
                                    text-gray-700 text-xs
                                    font-bold
                                    mb-2
                                    float-right
                                  ">Status: </label>
            </div>
            <div class="w-1/3 h-12">
                            <span v-if="traineePassed == true">
                                <v-icon color="success" left>mdi-check-decagram</v-icon> <b>PASSED</b>
                            </span>
              <span v-else-if="traineePassed == false">
                                <v-icon color="error" left>mdi-block-helper</v-icon> <b>FAILED</b>
                            </span>
              <span v-else-if="traineePassed == null">
                                <v-icon color="warning" left>mdi-alert-decagram</v-icon> Trainee's status will be shown
                                once score is
                                entered.
                            </span>
            </div>
          </div>
          <div class="flex my-4 mb-6 pb-3">
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label class="
                                    block
                                    uppercase
                                    tracking-wide
                                    text-gray-700 text-xs
                                    font-bold
                                    mb-2
                                    float-right
                                  ">Course Issue Date: </label>
            </div>
            <div class="w-1/3 h-12">
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                      :disabled="showWarning" :return-value.sync="formValues.courseCompletionDate"
                      min-width="auto" offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="formValues.courseCompletionDate"
                                label="Course Issue Date" prepend-icon="mdi-calendar" readonly
                                v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="formValues.courseCompletionDate" :max="date" no-title
                               scrollable>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="menu = false">
                    Cancel
                  </v-btn>
                  <v-btn color="primary" text
                         @click="$refs.menu.save(formValues.courseCompletionDate)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </div>
          <div class="flex my-4 mb-6 pb-3">
            <div class="w-full md:w-1/2 px-3 mb-6 required">
              <label class="
                                                block
                                                uppercase
                                                tracking-wide
                                                text-gray-700 text-xs
                                                font-bold
                                                mb-2
                                                float-right
                                            ">Certificate Reason: </label>
            </div>

            <div class="w-1/3 h-12">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-select v-model="formValues.certificate_reason" :disabled="showWarning" :elevation="1"
                          :items="CERTIFICATE_REASON" :loading="certReasonLoading" dense
                          hint="Select Certificate Reason"
                          item-text="name" return-object
                          solo>
                </v-select>

                <span class="text-gray-600 text-xs italic text-red-700">{{
                    errors[0]
                  }}</span>
              </validation-provider>
              <br/>
            </div>
          </div>
          <div class="d-flex flex-row-reverse mt-4 justify-center">
            <div class="w-1/3 h-12 mt-2">
              <div class="d-flex flex-row-reverse space-around mt-2">
                <v-btn v-if="$can('trainee', 'completeTraining')" :disabled="!(formValues.traineeStatusId == passId)" class="teal white--text mt-2" color="primary"
                       depressed
                       small
                       @click="updateCertificate('pass')">
                  <span>Submit for Approval</span>
                </v-btn>
                <v-btn v-if="$can('trainee', 'completeTraining')" :disabled="!(formValues.traineeStatusId == failId)" class="teal white--text mt-2 mr-2"
                       color="primary"
                       depressed small
                       @click="updateCertificate('fail')">
                  <span>update</span>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {max_value, min_value, required} from "vee-validate/dist/rules";
import {router} from "@/router";
import {getCertReason, isCertificateApprovalComplete} from "@/utils/helper";
import {TraineeService} from "./trainees.service";
import {generateCertificate1} from "./generate-certiificate";
import {settings} from "@/Settings";

extend("required", {
  ...required,
  message: "This field is required",
});

extend("min_value", {
  ...min_value,
  message: "Score can't be negative",
});
extend("max_value", {
  ...max_value,
  message: "Score can't be more than 100",
});
export default {
  props: {
    traineeUpdateCourseDetail: Object,
    traineeStatus: Array,
    courseCompletionDialog: Boolean,
    userInfo: Object,
    traineeType: String,
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      loading: false,
      formValues: {
        score: null,
        traineeStatusId: null,
        courseCompletionDate: null,
        certificate_reason: null,
        course: {
          passingScore: null
        }
      },
      passingScore: null,
      showWarning: false,
      traineePassed: null,
      passId: "",
      failId: "",
      menu: false,
      modal: false,
      menu2: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
      CERTIFICATE_REASON: [],
      certReasonLoading: false,
      isCategory1: null,
      imageSrc: '',
      url: "",
    }
  },
  async created() {
    await this.initLookups();
    if (this.traineeUpdateCourseDetail != null) {
      const categoryType = this.traineeUpdateCourseDetail.program.category
          .categoryType;
      categoryType == "CAT1"
          ? (this.isCategory1 = true)
          : (this.isCategory1 = false);
      this.formValues = this.traineeUpdateCourseDetail;
    }
    this.assignStatusId();

    this.passingScore = this.formValues.course ? (this.formValues.course.passingScore ? this.formValues.course.passingScore : null) : (this.formValues.program ? this.formValues.program.cat2PassingScore : null);
    if (this.passingScore == null) {
      this.showWarning = true;
    }

    const score = this.formValues.score ? +this.formValues.score : null;
    this.calculateTraineeStatus(score);
  },
  methods: {
    async initLookups() {
      this.certReasonLoading = true;
      const certResp = await getCertReason();
      this.CERTIFICATE_REASON = certResp?.rows.filter(data => {
        return data.isActive === true;
      })
      this.certReasonLoading = false;
    },
    calculateTraineeStatus(score) {
      const enteredScore = score != '' ? (+score) : null;
      if (enteredScore == null) {
        this.traineePassed = null;
      } else if (enteredScore >= this.passingScore || enteredScore == 100) {
        this.formValues.traineeStatusId = this.passId;
        this.traineePassed = true;
      } else if (enteredScore < this.passingScore) {
        this.formValues.traineeStatusId = this.failId;
        this.traineePassed = false;
      } else {
        this.traineePassed = null;
      }
    },
    assignStatusId() {
      this.traineeStatus.map((e) => {
        this.passId = e.code == "PASS" ? e.id : this.passId;
        this.failId = e.code == "FAIL" ? e.id : this.failId;
      });
    },
    async updateCertificate(status) {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.loading = true;
      if (status === "pass") {
        this.formValues.certificateApprovalStatus = "PENDING";
      } else {
        this.formValues.certificateApprovalStatus = null;
      }
      if (this.traineeType == "new") {
        if (this.isCategory1 == true) {
          this.formValues.certificateReasonId = this.formValues.certificate_reason.id;
          const res = await TraineeService.completeNewTraineeCourse(this.formValues);
          this.loading = false;
          if (res.data.status === 200 || res.data.status === 201) {
            if (status === "pass") {
              this.$toast.success("Course updated. Certificate pending approval.");
              router.go();
            } else if (status === "fail") {
              router.go();
            }
          }
        } else {
          this.formValues.certificateReasonId = this.formValues.certificate_reason.id;
          const res = await TraineeService.completeNewTCat2Course(this.formValues);
          this.loading = false;
          if (res.data.status === 200 || res.data.status === 201) {
            if (status === "pass") {
              this.$toast.success("Course updated. Certificate pending approval.");
              router.go();
            } else if (status === "fail") {
              router.go();
            }
          }
        }
      } else if (this.traineeType == "old") {
        if (this.isCategory1 == true) {
          this.formValues.certificateReasonId = this.formValues.certificate_reason.id;
          const res = await TraineeService.completeTraineeCourse(this.formValues);
          this.loading = true;
          if (res.data.status === 200 || res.data.status === 201) {
            if (status === "pass") {
              this.$toast.success("Course updated. Certificate pending approval.");
              router.go();
            } else if (status === "fail") {
              router.go();
            }
          }
        } else {
          this.formValues.certificateReasonId = this.formValues.certificate_reason.id;
          const res = await TraineeService.completeTraineeCat2Course(this.formValues);
          this.loading = true;
          if (res.data.status === 200 || res.data.status === 201) {
            if (status === "pass") {
              this.$toast.success("Course updated. Certificate pending approval.");
              router.go();
            } else if (status === "fail") {
              router.go();
            }
          }
        }
      }
    },
    async generateCerteficate(type) {
      if (!isCertificateApprovalComplete(this.traineeUpdateCourseDetail)) {
        this.$toast.warning("Certificate is pending approval.");
        return;
      }
      const traineeType = type;
      const updateId =
          this.traineeUpdateCourseDetail?.traineeUpdateId ||
          this.traineeUpdateCourseDetail?.newTraineesUpdateId;

      if (traineeType === "New") {
        this.url = settings.FRONT_URL + "newTraineeInformation/" + updateId;
      } else if (traineeType === "Old") {
        this.url = settings.FRONT_URL + "traineeInformation/" + updateId;
      }

      const qrParams = {
        url: this.url
      }

      const res = await TraineeService.generateQrCode(qrParams);

      if (res.status === 200 || res.status === 201) {
        this.imageSrc = res.data;
        switch (res.data.status) {
          case 200 || 201:
            generateCertificate1(this.traineeUpdateCourseDetail, this.userInfo, this.imageSrc.data);
            break;
          case 500:
            this.$toast.error(res.data.message);
            break;
        }
        // this.historyLoading = false;
      } else {
        // this.historyLoading = false;
        this.$toast.error("Unable to generate trainee certificate, please try again");
      }
    },
    redirectToCourse() {
      this.isCategory1 ? this.$router.push("/course") : this.$router.push("/cpdActivity");
    },

  }

}
</script>
